import { emptyPlaceholder } from '~/utils/constant';
import type { Component } from 'solid-js';
import type { PropertyDto, UnitDto } from '~/swagger/portal/Api';

export const TransactionLeaseName: Component<{ property?: PropertyDto | null; unit?: UnitDto | null }> = (props) => (
  <>{props.property && props.unit ? `${props.property?.displayName}, ${props.unit?.name}` : emptyPlaceholder}</>
);
